import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthStore } from '../../features/login/store/auth.store';
import { SharedUIService } from '../../../shared/services';
import { FormBuilderStore } from '../../features/form-builder/store/form-builder.store';

export const formTemplateAccessGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const store = inject(FormBuilderStore);
  const authStore = inject(AuthStore);
  const router = inject(Router);
  const sharedUIService = inject(SharedUIService);

  const templateId = route.paramMap.get('templateId');
  const currentUser = authStore.currentUser();

  if (!templateId || !currentUser) {
    router.navigate(['/form-builder']);
    return false;
  }

  if (templateId === 'template-builder') {
    return true;
  }

  const template = store.entities().find((t) => t.id === templateId);

  if (!template) {
    sharedUIService.withCloseAction('Form template not found');
    router.navigate(['/form-builder']);
    return false;
  }

  const userRoleId =
    typeof currentUser.userRole === 'string'
      ? currentUser.userRole
      : currentUser.userRole?.id;

  const hasAccess = template.assignedTo.includes(userRoleId!);

  if (!hasAccess) {
    sharedUIService.withCloseAction(
      'You do not have access to this form template',
    );
    router.navigate(['/form-builder']);
    return false;
  }

  return true;
};
